import { jsx as _jsx } from "react/jsx-runtime";
export const DynamicAdSlot = ({ content }) => {
    return (_jsx("iframe", { title: "Coolblue ad", srcDoc: content, sandbox: "allow-scripts", style: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 'none',
            pointerEvents: 'none',
        } }));
};
//# sourceMappingURL=DynamicAdSlot.js.map